module.exports = __webpack_public_path__ + "img/1_034.9e954d7f.jpg";